// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bgvModal {
  overflow: hidden !important;
}
.bgvModal .bgvModalDialog .modal-content {
  position: relative;
  max-height: calc(100vh - 50px);
  overflow-y: auto;
}
@media screen and (max-width: 601px) {
  .bgvModal .bgvModalDialog .modal-content {
    max-height: 100%;
    height: 100%;
  }
}
.bgvModal .bgvModalDialog .modal-header {
  position: sticky;
  box-shadow: 0 0px 10px rgba(23, 26, 30, 0.1);
  padding: 15px 30px;
  top: 0;
  left: 0;
  background: #fff;
  z-index: 1000;
}
.bgvModal .bgvModalDialog .modal-header .modal-title {
  margin-top: 0;
}
@media screen and (min-width: 992px) {
  .bgvModal .bgvModalDialog .modal-header {
    padding: 15px 30px;
  }
}
.bgvModal .bgvModalDialog .modal-footer {
  position: sticky;
  bottom: 0;
  left: 0;
  box-shadow: 0 -2px 10px rgba(23, 26, 30, 0.1);
  margin: 0;
  padding: 8px 30px !important;
  background: #fff;
}
@media screen and (min-width: 992px) {
  .bgvModal .bgvModalDialog .modal-footer {
    padding: 15px 30px !important;
  }
}
@media only screen and (max-width: 600px) {
  .bgvModal .bgvModalDialog {
    margin: 0px;
    top: auto;
    min-height: 100%;
    height: 100%;
    max-width: 100%;
  }
}

.bgvModalPrimaryBtn {
  border-radius: 2px;
  padding: 0.3em 1.4rem;
  margin: 4px;
  width: 100%;
  height: 40px;
  margin: 0;
  width: 160px;
  background: #2755fe;
  color: #ffffff;
  cursor: pointer;
}
.bgvModalPrimaryBtn:disabled {
  background: #f5f5f5;
  color: #dfdfdf;
  border: 1px solid #d9d9d9;
  cursor: not-allowed;
}

.bgvModalSecondaryBtn {
  width: 140px;
  background: #ffffff;
  color: #2755fe;
  border: none;
  margin-right: 32px;
  box-shadow: none;
  font-size: 16px;
  font-family: Poppins, sans-serif;
}
.bgvModalSecondaryBtn:hover {
  background: #ffffff;
  color: #2755fe;
  border: none;
}
.bgvModalSecondaryBtn:active {
  background: #ffffff !important;
  color: #2755fe !important;
  border: none !important;
}
.bgvModalSecondaryBtn:focus {
  box-shadow: none !important;
}`, "",{"version":3,"sources":["webpack://./src/styles/_bgvModalStyles.scss"],"names":[],"mappings":"AAAA;EACE,2BAA2B;AAC7B;AACA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,gBAAgB;AAClB;AACA;EACE;IACE,gBAAgB;IAChB,YAAY;EACd;AACF;AACA;EACE,gBAAgB;EAChB,4CAA4C;EAC5C,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,OAAO;EACP,6CAA6C;EAC7C,SAAS;EACT,4BAA4B;EAC5B,gBAAgB;AAClB;AACA;EACE;IACE,6BAA6B;EAC/B;AACF;AACA;EACE;IACE,WAAW;IACX,SAAS;IACT,gBAAgB;IAChB,YAAY;IACZ,eAAe;EACjB;AACF;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,SAAS;EACT,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gCAAgC;AAClC;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;AACd;AACA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,uBAAuB;AACzB;AACA;EACE,2BAA2B;AAC7B","sourcesContent":[".bgvModal {\n  overflow: hidden !important;\n}\n.bgvModal .bgvModalDialog .modal-content {\n  position: relative;\n  max-height: calc(100vh - 50px);\n  overflow-y: auto;\n}\n@media screen and (max-width: 601px) {\n  .bgvModal .bgvModalDialog .modal-content {\n    max-height: 100%;\n    height: 100%;\n  }\n}\n.bgvModal .bgvModalDialog .modal-header {\n  position: sticky;\n  box-shadow: 0 0px 10px rgba(23, 26, 30, 0.1);\n  padding: 15px 30px;\n  top: 0;\n  left: 0;\n  background: #fff;\n  z-index: 1000;\n}\n.bgvModal .bgvModalDialog .modal-header .modal-title {\n  margin-top: 0;\n}\n@media screen and (min-width: 992px) {\n  .bgvModal .bgvModalDialog .modal-header {\n    padding: 15px 30px;\n  }\n}\n.bgvModal .bgvModalDialog .modal-footer {\n  position: sticky;\n  bottom: 0;\n  left: 0;\n  box-shadow: 0 -2px 10px rgba(23, 26, 30, 0.1);\n  margin: 0;\n  padding: 8px 30px !important;\n  background: #fff;\n}\n@media screen and (min-width: 992px) {\n  .bgvModal .bgvModalDialog .modal-footer {\n    padding: 15px 30px !important;\n  }\n}\n@media only screen and (max-width: 600px) {\n  .bgvModal .bgvModalDialog {\n    margin: 0px;\n    top: auto;\n    min-height: 100%;\n    height: 100%;\n    max-width: 100%;\n  }\n}\n\n.bgvModalPrimaryBtn {\n  border-radius: 2px;\n  padding: 0.3em 1.4rem;\n  margin: 4px;\n  width: 100%;\n  height: 40px;\n  margin: 0;\n  width: 160px;\n  background: #2755fe;\n  color: #ffffff;\n  cursor: pointer;\n}\n.bgvModalPrimaryBtn:disabled {\n  background: #f5f5f5;\n  color: #dfdfdf;\n  border: 1px solid #d9d9d9;\n  cursor: not-allowed;\n}\n\n.bgvModalSecondaryBtn {\n  width: 140px;\n  background: #ffffff;\n  color: #2755fe;\n  border: none;\n  margin-right: 32px;\n  box-shadow: none;\n  font-size: 16px;\n  font-family: Poppins, sans-serif;\n}\n.bgvModalSecondaryBtn:hover {\n  background: #ffffff;\n  color: #2755fe;\n  border: none;\n}\n.bgvModalSecondaryBtn:active {\n  background: #ffffff !important;\n  color: #2755fe !important;\n  border: none !important;\n}\n.bgvModalSecondaryBtn:focus {\n  box-shadow: none !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
